<div class="form-section">
  <label [attr.for]="id" [class.required-field]="required" *ngIf="label">{{ label }}</label>
  
  <!-- 多列模式 -->
  <div class="fill-in-container multi-row" *ngIf="isMultiRowMode()">
    <!-- 統一的色塊容器 -->
    <div class="fill-in-group">
      <div class="fill-in-row" *ngFor="let row of parsedRows; trackBy: trackByRowId">
        <!-- 列內容 - 包含 checkbox 和填空內容在同一行 -->
        <div class="row-content" [class.disabled-row]="row.hasCheckbox && !row.isChecked">
          <!-- 可選的 Checkbox - 放在內容前面 -->
          <div class="row-checkbox-inline" *ngIf="row.hasCheckbox">
            <input 
              type="checkbox" 
              [id]="'checkbox-' + row.id"
              [checked]="row.isChecked"
              (change)="onCheckboxChange(row.id, $event)"
              class="form-check-input"
            />
            <label 
              [for]="'checkbox-' + row.id" 
              class="form-check-label checkbox-label"
              *ngIf="row.checkboxLabel"
            >
              {{ row.checkboxLabel }}
            </label>
          </div>
        <ng-container *ngFor="let part of row.template.parts">
          <!-- 靜態文字部分 -->
          <span *ngIf="part.type === 'text'" class="fill-in-text">{{ part.content }}</span>
          
          <!-- 填空格部分 -->
          <ng-container *ngIf="part.type === 'field' && part.fieldId">
            <!-- 預覽模式 -->
            <div *ngIf="preview" class="fill-in-field preview" [ngClass]="getFieldClass(part.fieldConfig)">
              [{{ part.fieldId }}]
            </div>
            
            <!-- 編輯模式：已勾選或無Checkbox時顯示填空欄位 -->
            <input 
              *ngIf="!preview && shouldShowFieldInput(row.id)"
              [type]="getInputType(part.fieldConfig)"
              [placeholder]="getPlaceholder(part.fieldConfig)"
              [ngModel]="fieldValues[part.fieldId]"
              (ngModelChange)="onFieldValueChange(part.fieldId, $event)"
              (blur)="onTouched()"
              [class]="getFieldClass(part.fieldConfig)"
            />
            
            <!-- 編輯模式：未勾選時顯示下底線 -->
            <span 
              *ngIf="!preview && !shouldShowFieldInput(row.id)"
              class="fill-in-placeholder"
              [ngClass]="getFieldClass(part.fieldConfig)"
            >
              _____
            </span>
          </ng-container>
        </ng-container>
      </div>
    </div>
    </div> <!-- 關閉 fill-in-group -->
  </div>
  
  <!-- 單列模式（向後相容） -->
  <div class="fill-in-container single-row" *ngIf="!isMultiRowMode() && hasTemplate()">
    <ng-container *ngFor="let part of parsedTemplate.parts">
      <!-- 靜態文字部分 -->
      <span *ngIf="part.type === 'text'" class="fill-in-text">{{ part.content }}</span>
      
      <!-- 填空格部分 -->
      <ng-container *ngIf="part.type === 'field' && part.fieldId">
        <!-- 預覽模式 -->
        <div *ngIf="preview" class="fill-in-field preview" [ngClass]="getFieldClass(part.fieldConfig)">
          [{{ part.fieldId }}]
        </div>
        
        <!-- 編輯模式 -->
        <input 
          *ngIf="!preview"
          [type]="getInputType(part.fieldConfig)"
          [placeholder]="getPlaceholder(part.fieldConfig)"
          [ngModel]="fieldValues[part.fieldId]"
          (ngModelChange)="onFieldValueChange(part.fieldId, $event)"
          (blur)="onTouched()"
          [class]="getFieldClass(part.fieldConfig)"
        />
      </ng-container>
    </ng-container>
  </div>

  <!-- 後備模式：顯示已完成的填空內容（當沒有配置但有值時） -->
  <div class="fill-in-container fallback-mode" *ngIf="!isMultiRowMode() && !hasTemplate() && hasCompletedContent()">
    <div class="completed-fill-in-content">
      <!-- 如果有 HTML 內容，使用 innerHTML 顯示 -->
      <div *ngIf="getCompletedHtml(); let htmlContent" [innerHTML]="htmlContent" class="fill-in-html-content"></div>
      <!-- 如果只有純文字內容，顯示文字 -->
      <div *ngIf="!getCompletedHtml() && getCompletedText(); let textContent" class="fill-in-text-content">
        {{ textContent }}
      </div>
      <!-- 如果都沒有，顯示基本資訊 -->
      <div *ngIf="!getCompletedHtml() && !getCompletedText()" class="fill-in-basic-info">
        <p class="text-muted">填空內容：{{ getSummaryText() || '已填寫' }}</p>
      </div>
    </div>
  </div>
</div>